var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "chat-sidebar-esqueleto",
      class: { "chat-sidebar-esqueleto--navegacao": _vm.navegacao },
      attrs: { "aria-hidden": "true" }
    },
    _vm._l(_vm.linhas, function(linha) {
      return _c(
        "div",
        {
          key: linha.chave,
          staticClass: "chat-sidebar-esqueleto__linha ia-shimmer-pulso"
        },
        [
          !_vm.navegacao
            ? _c("BaseLoadingSkeleton", {
                staticClass: "chat-sidebar-esqueleto__icone",
                attrs: { width: "14px", height: "14px" }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "chat-sidebar-esqueleto__titulo" },
            [
              _c("BaseLoadingSkeleton", {
                attrs: { width: linha.titulo, height: "12px" }
              })
            ],
            1
          ),
          _vm.navegacao
            ? _c(
                "div",
                { staticClass: "chat-sidebar-esqueleto__data" },
                [
                  _c("BaseLoadingSkeleton", {
                    attrs: { width: linha.data, height: "10px" }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }